import { useState, useEffect  } from 'react';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { likewriterActions } from "_store";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Table from 'react-bootstrap/Table';
import { useNavigate } from "react-router-dom";
export { WriteEssay };

function WriteEssay() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = useState("");
  const { user: authUser } = useSelector((x) => x.auth);
  const { likewriter } = useSelector((x) => x.likewriter);
  const [correctedText, setCorrectedText] = useState("");
  const [errors, setErrors] = useState([]);
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [charCount, setCharCount] = useState(0);
  const [wordCount, setWordCount] = useState(0);
  const [sentenceCount, setSentenceCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState("Without Countdown Timer");
  const [textInput, setTextInput] = useState("");
  const [ grammarScore, setGrammarScore] = useState(0);
  const [ vocabularyScore, setVocabularyScore] = useState(0);
  const [ cohesionScore, setCohesion] = useState(0);
  const [ organizationScore, setOrganization] = useState(0);
  const [ contentScore, setContent] = useState(0);
  const [ grammarFeedback, setGrammarFeedback] = useState('');
  const [ vocabularyFeedback, setVocabularyFeedback] = useState('');
  const [ cohesionFeedback, setCohesionFeedback] = useState('');
  const [ organizationFeedback, setOrganizationFeedback] = useState('');
  const [ contentFeedback, setContentFeedback] = useState('');
  const [timeLeft, setTimeLeft] = useState(60 * 60); // 60 minutes in seconds
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [saving, setSaving] = useState(false);
  const [lexileScore, setLexileScore] = useState(null);
  const YOUR_OPENAI_API_KEY = 'Bearer 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';
  const handleRadioChange = (e) => {
    setSelectedOption(e.target.value);
    if (e.target.value === "With Countdown Timer") {
      setTimeLeft(60 * 60); // Reset timer to 60 minutes
      setIsTimerRunning(true);
    } else {
      setIsTimerRunning(false);
    }
  };
  const handleTextInputChange = (e) => setTextInput(e.target.value);
  const handleGrammarCheck = async () => {
    if (!text.trim()) {
      alert("Please write an essay and submit it again for a grammar check.");
      return;
    }
  
    setLoading(true);
    try {
       const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content: `Evaluate the following essay:
              ${text}
      
              Provide a JSON response with:
        - Content & Ideas (score out of 100 + feedback)
        - Organization (score out of 100 + feedback)
        - Grammar & Mechanics (score out of 100 + feedback)
        - Vocabulary Use (score out of 100 + feedback)
        - Coherence & Cohesion (score out of 100 + feedback)
        - Total Score (out of 100)
        - Corrected text
        - Errors (list of wrong words and suggestions)
        - Grammar punctuation score (0-100)
        - Vocabulary score (0-100)
        - Character count, word count, and sentence count.
        - **Lexile Score** (a numerical value estimating the reading difficulty level)

        Ensure all scores are out of 100. Respond in JSON format only (no explanations, no markdown).`,
            },
          ],
          temperature: 0,
          top_p: 0,
          seed: 1234
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: YOUR_OPENAI_API_KEY,
          },
        }
      );
      
      // Clean the response by removing any triple backticks and unnecessary formatting
      let responseDataText = response.data.choices[0].message.content.trim();
      responseDataText = responseDataText.replace(/```json|```/g, "").trim();
     
  
      const responseData = JSON.parse(responseDataText);
      console.log(responseData,'responseData');
      // Extract and rename the fields
      const {
        "Lexile Score": lexile_score, // Add this line
        "Content & Ideas": content_ideas,
        "Organization": organization,
        "Grammar & Mechanics": grammar_mechanics,
        "Vocabulary Use": vocabulary_use,
        "Coherence & Cohesion": coherence_cohesion,
        "Total Score": total_score,
        "Corrected text": corrected_text,
        "Errors": errors,
        "Character count": character_count,
        "Word count": word_count,
        "Sentence count": sentence_count,
      } = responseData;

      setLexileScore(lexile_score);
      setCorrectedText(corrected_text);
      setErrors(errors);
      setScore(total_score);
      setCharCount(character_count);
      setWordCount(word_count);
      setSentenceCount(sentence_count);
      setGrammarScore(grammar_mechanics.score);
      setVocabularyScore(vocabulary_use.score);
      setContent(content_ideas.score);
      setOrganization(organization.score);
      setCohesion(coherence_cohesion.score);
      setGrammarFeedback(grammar_mechanics.feedback);
      setVocabularyFeedback(vocabulary_use.feedback);
      setContentFeedback(content_ideas.feedback);
      setOrganizationFeedback(organization.feedback);
      setCohesionFeedback(coherence_cohesion.feedback);
     
    } catch (error) {
      console.error("Error:", error);
      //alert("Something went wrong! Please try again.");
    }
    setLoading(false);
  };
  

  const handlePrint = () => window.print();


  const handleSave = async () => {
    if (!text.trim() || !textInput.trim()) {
      alert("Please enter a title and content before saving.");
      return;
    }
    setSaving(true);
    try {
        const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-4o",
          messages: [
            {
              role: "user",
              content: `Evaluate the following essay:
              ${text}
      
              Provide a JSON response with:
        - Content & Ideas (score out of 100 + feedback)
        - Organization (score out of 100 + feedback)
        - Grammar & Mechanics (score out of 100 + feedback)
        - Vocabulary Use (score out of 100 + feedback)
        - Coherence & Cohesion (score out of 100 + feedback)
        - Total Score (out of 100)
        - Corrected text
        - Errors (list of wrong words and suggestions)
        - Grammar punctuation score (0-100)
        - Vocabulary score (0-100)
        - Character count, word count, and sentence count.
        - **Lexile Score** (a numerical value estimating the reading difficulty level)

        Ensure all scores are out of 100. Respond in JSON format only (no explanations, no markdown).`,
            },
          ],
          temperature: 0,
          top_p: 0,
          seed: 1234
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: YOUR_OPENAI_API_KEY,
          },
        }
      );
      
      // Clean the response by removing any triple backticks and unnecessary formatting
      let responseDataText = response.data.choices[0].message.content.trim();
      responseDataText = responseDataText.replace(/```json|```/g, "").trim();
     
  
      const responseData = JSON.parse(responseDataText);
      // Extract and rename the fields
const {
  "Lexile Score": lexile_score, // Add this line
  "Content & Ideas": content_ideas,
  "Organization": organization,
  "Grammar & Mechanics": grammar_mechanics,
  "Vocabulary Use": vocabulary_use,
  "Coherence & Cohesion": coherence_cohesion,
  "Total Score": total_score,
  "Corrected text": corrected_text,
  "Errors": errors,
  "Character count": character_count,
  "Word count": word_count,
  "Sentence count": sentence_count,
} = responseData;
setLexileScore(lexile_score);
      setCorrectedText(corrected_text);
      setErrors(errors);
      setScore(total_score);
      setCharCount(character_count);
      setWordCount(word_count);
      setSentenceCount(sentence_count);
      setGrammarScore(grammar_mechanics.score);
      setVocabularyScore(vocabulary_use.score);
      setContent(content_ideas.score);
      setOrganization(organization.score);
      setCohesion(coherence_cohesion.score);
      setGrammarFeedback(grammar_mechanics.feedback);
      setVocabularyFeedback(vocabulary_use.feedback);
      setContentFeedback(content_ideas.feedback);
      setOrganizationFeedback(organization.feedback);
      setCohesionFeedback(coherence_cohesion.feedback);
       var student_id = authUser.user.student_id;
       var teacher_id = authUser.user.teacher_id;
       var title = textInput;
       var essay = text;
      var response1 =  dispatch(likewriterActions.createEssay({ student_id, teacher_id,title,essay,character_count, word_count,sentence_count,vocabulary_use: JSON.stringify(vocabulary_use) ,corrected_text,errors: JSON.stringify(errors),content:JSON.stringify(content_ideas), organization: JSON.stringify(organization),grammar_mechanics:JSON.stringify(grammar_mechanics),coherence_cohesion:JSON.stringify(coherence_cohesion),total_score,lexile_score }));
  console.log(response,'get response');
  toast.success('Essay saved successfully.', {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    });
    history.navigate('/essay/MyWritingList');
    } catch (error) {
      console.error("Save Error:", error);
     // alert("An error occurred while saving. Please try again.");
    }
    setSaving(false);
  };
  

  const handleStopAndSave = () => {
    setIsTimerRunning(false);
    handleSave();
  };

  useEffect(() => {
    if (isTimerRunning && timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [isTimerRunning, timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };
  console.log(lexileScore,'lexile_score');
  return (
    <section className="custom-sign write-essay">
    <div className="container">
     {/* Buttons */}
     <div className="write-essay-buttons" style={{ display: "flex", gap: "10px" }}>
          <button onClick={handleGrammarCheck} disabled={loading}>{loading ? "Checking..." : "Grammar & Spell Checker"}</button>
          <button onClick={handlePrint}>Print</button>
          <button onClick={handleSave}>Save</button>
        </div>
        {/* Radio Buttons in a Single Row */}
        <div className="write-essay-radio" style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
        <label>
            <input
              type="radio"
              name="timerOption"
              value="Without Countdown Timer"
              checked={selectedOption === "Without Countdown Timer"}
              onChange={handleRadioChange}
              style={{ marginRight: "5px" }}
            />
            Without Countdown Timer
          </label>
          <label>
            <input
              type="radio"
              name="timerOption"
              value="With Countdown Timer"
              checked={selectedOption === "With Countdown Timer"}
              onChange={handleRadioChange}
              style={{ marginRight: "5px" }}
            />
            With Countdown Timer
          </label>
          
        </div>
        {/* Timer Display */}
        {selectedOption === "With Countdown Timer" && (
          <div className="write-essay-countdown-timer" style={{ marginTop: "10px", padding: "10px", border: "1px solid #ccc", background: "#f8f8f8" }}>
            <h3>Countdown Timer: {formatTime(timeLeft)}</h3>
            <button onClick={handleStopAndSave} style={{ marginTop: "10px" }}>
              Stop & Save
            </button>
          </div>
        )}
        {/* Title Input */}

        <div className="write-essay-title-input">
        <input
          type="text"
          placeholder="Type title here"
          value={textInput}
          onChange={handleTextInputChange}
          style={{ width: "100%", padding: "8px", display: "block" }}
        />
        </div>
      {/* Textarea Input */}
      <div className="like-writer-textarea" style={{ marginBottom: "10px" }}>
      <textarea
        placeholder="Type or paste your text here..."
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows="5"
        style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
      ></textarea>
      </div>

      {/* Corrected Output with Strikethrough and Bold */}
      {correctedText && (
  <div style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f8f8f8" }}>

 <p className="strikethrough-boldfaces-text">
  {(() => {
    if (!text || errors.length === 0) return <span>{text}</span>; 

    let modifiedText = text;

    errors.forEach((error) => {
      // Support both "wrong" and "wrong_word"
      const wrongWord = error.wrong || error.wrong_word;
      const suggestion = error.suggestion;

      if (!wrongWord || !suggestion) return;

      // Escape regex special chars
      const escapedWrong = wrongWord.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      // Whole word replacement, case-insensitive
      const regex = new RegExp(`\\b${escapedWrong}\\b`, "gi");

      modifiedText = modifiedText.replace(
        regex,
        `<span style="text-decoration: line-through; color: red;">${wrongWord}</span> 
         &nbsp;<span style="font-weight: bold; color: green;">${suggestion}</span>`
      );
    });

    return <span dangerouslySetInnerHTML={{ __html: modifiedText }} />;
  })()}
  <span className="arrow-section">↓</span>
</p>

    <p className="chatgpt-corrected-text">
    <span>{correctedText}</span>
    </p>
  </div>
)}


{(score > 0) ? 
<Table striped bordered responsive>
    <thead>
      <tr>
        <th colSpan={5} style={{ textAlign: "center" }}>
        LIKE Editor Score Report
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Name</td>
        <td>{authUser.user.name}</td>
        <td rowspan="5" className="result">
          {(score) >= 50 ? <h4 style={{ color: "green" }}>Pass ({lexileScore}L)</h4>: <h4 style={{ color: "red" }}>Fail ({lexileScore}L)</h4>}
          {/* {(score) >= 2.5 ? <h4 style={{ color: "green" }}>Pass</h4>: <h4 style={{ color: "red" }}>Fail</h4>} */}
        </td>
      </tr>
      <tr>
        <td>Test Date</td>
        <td>{new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "2-digit",
    year: "numeric",
  })}</td>
      </tr>
      <tr>
        <td>Character Count</td>
        <td>{charCount}</td>
      </tr>
      <tr>
        <td>Word Count</td>
        <td>{wordCount}</td>
      </tr>
      <tr>
        <td>Sentence Count</td>
        <td>
        {sentenceCount}
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Scores</td>
        <td colSpan={5}>Comments</td>
      </tr>
      <tr>
        <td>Content</td>
        <td>{contentScore}</td>
        <td colSpan={5}> {contentFeedback}</td>
      </tr>
      <tr>
        <td>Organization</td>
        <td>{organizationScore}</td>
        <td colSpan={5}> {organizationFeedback}</td>
      </tr>
      <tr>
        <td>Grammar and Mechanics</td>
        <td>{grammarScore }</td>
        <td colSpan={5}> {grammarFeedback}</td>
      </tr>
      <tr>
        <td>Vocabulary Use</td>
        <td>{vocabularyScore}</td>
        <td colSpan={5}> {vocabularyFeedback}</td>
      </tr>
      <tr>
        <td>Coherence and Cohesion</td>
        <td>{cohesionScore }</td>
        <td colSpan={5}>{cohesionFeedback}</td>
      </tr>
      <tr>
        <td>Overall Evaluation</td>
        <td>{score}</td>
        <td colSpan={5}>Your writing shows relatively low proficiency and skills. It contains some noticeable mistakes and errors in grammar, punctuation, organization, usage, and style, and they sometimes hinder the meanings.</td>
      </tr>

    </tbody>
  </Table>
  : ''}

      {/* Text Statistics */}
      <div className="write-essay-count" style={{ marginTop: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>Character Count:</strong> {charCount}</p>
        <p><strong>Word Count:</strong> {wordCount}</p>
        <p><strong>Sentence Count:</strong> {sentenceCount} </p>
      </div>
      <div className="write-essay-grammar-spelling-issue" style={{ ax: "20px", padding: "10px", border: "1px solid #ccc", background: "#f2f2f2" }}>
        <p><strong>{(errors && errors.length > 0) ? errors.length : 0}</strong> Grammar & Spelling issues</p>
       
      </div>
    </div>
    </section>
  );
}
